import "../../components/atoms/buttons/button.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import "./../login/login.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/atoms/buttons/Button";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import ButtonVolver from "../../components/atoms/buttons/ButtonVolver";
import {
  getDatoBorradores,
  getDatoPresentada,
  validarAlta,
} from "../../components/services/DatoPersonalService";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import AcumuladoresTabActosReconServiciosPrevios from "../../components/molecules/tabs/acumuladoresTab/AcumuladoresTabActosReconServiciosPrevios";

const ReconServiciosPrevios = () => {
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState({
    borradores: false,
    solicitudes: false,
  });
  const navigate = useNavigate();
  const [borradores, setBorradores] = useState([""]);
  const [actosPresentados, setActosPresentados] = useState([]);
  const [errorBorrador, setErrorBorrador] = useState(false);
  const [errorPresentada, setErrorresentada] = useState(false);
  const { state } = useLocation();
  const [accesoPDF] = useState(state?.accesoPDF);
  const [show, setShow] = useState({
    mensaje: false
  });

  useEffect(() => {
    setLoading(true);

    getDatoBorradores("18").then((data) => {
      
      if (data !== undefined) {
        setBorradores(data);
        setLoadingData((prevState) => ({
          ...prevState,
          borradores: true,
        }));
      } else {
        setErrorBorrador(true);
      }
    });
    getDatoPresentada("18").then((data) => {
      
      if (data !== undefined || !data.toString().startsWith("Error:")) {
        setActosPresentados(data);
        setLoadingData((prevState) => ({
          ...prevState,
          solicitudes: true,
        }));
      } else {
        setErrorresentada(true);
      }
    });
  }, []);

  const handleActualizarPresentada = () => {
    getDatoPresentada("18").then((data) => {
      
      if (data !== undefined || !data.toString().startsWith("Error:")) {
        setActosPresentados(data);
        setLoadingData((prevState) => ({
          ...prevState,
          solicitudes: true,
        }));
      } else {
        setErrorresentada(true);
      }
    });
  }

  const handleClose = (e) => {
    setShow(false);
  };
  function ReconServiciosPrevios() {
    return (
      <>
        <div className="vh-100">
          <Header></Header>
          <div className="contanier d-flex flex-column align-items-center my-lg-5 my-md-5 my-sm-3 py-2"
            role="main" data-landmark-index="4"
          >
            {loading ? (
              <>
                <div className="container d-flex justify-content-start">
                  {/*<Titulo
                    tipo={"tituloModal "}
                    titulo={"Variación de datos personales"}
                  />*/}
                  <h2 className="tituloAccesibilidadMini">Reconocimiento de servicios previos en Otras Administraciones</h2>
                </div>
                <p className="mt-2">Acto 18 - Reconocimiento de servicios previos en Otras Administraciones</p>

                {/* Borradores y Actos presentados */}
                <div className="row d-flex justify-content-center tablaRecNivel">
                  <div className="col-12 card pb-5">
                    {loadingData.borradores && loadingData.solicitudes ? (
                      <AcumuladoresTabActosReconServiciosPrevios
                        borradores={borradores}
                        setBorradores={setBorradores}
                        actosPresentados={actosPresentados}
                        setActosPresentados={setActosPresentados}
                        handleActualizarPresentada={handleActualizarPresentada}
                        loading={loadingData}
                        errorBorrador={errorBorrador}
                        errorPresentada={errorPresentada}
                        accesoPDF={accesoPDF}
                      />
                    ) : (
                      <SpinnerCircle></SpinnerCircle>
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <ButtonVolver
                    destino={"listadoactos"}
                    clases="col-3 mt-3 mb-3"
                  ></ButtonVolver>
                  {borradores.length < 10 ? (
                    //añadir validar alta
                    <Button
                      id="btnNuevaSolicitudNC"
                      clases="btn-card rounded seleccion-mes mt-3 mb-3"
                      nombre={
                        <>
                          <i className="fa-solid fa-file-circle-plus"></i> Nuevo
                          Borrador
                        </>
                      }
                      tipo="button"
                      funcion={() => {
                        validarAlta(-1, "s1").then((data) => {
                          
                          
                          if (data.estado) {
                            navigate("/solReconServiciosPrevios")
                          } else {
                            setShow({
                              mensaje: true,
                              content: data.descripcion,
                              tipo: "tituloModal",
                              aviso: false,
                              destinoAviso: null,
                              destinoCerrar: null,
                            });
                          }
                        })
                      }}
                    />
                  ) : null}
                </div>
              </>
            ) : (
              <></>
            )}
            <br />
          </div>
          <Footer></Footer>
          {show.mensaje ? (
            <>
              {" "}
              <ModalMensajes
                show={show.mensaje}
                handleClose={handleClose}
                content={show.content}
                content2={show.content2}
                tipo={show.tipo}
                aviso={show.aviso}
                destinoAviso={show.destinoAviso}
                destinoCerrar={show.destinoCerrar}
                funcion={show.funcion}
                valorFuncion={show.valorFuncion}
                boton={show.boton}
                contentBold={show.contentBold}
              ></ModalMensajes>
            </>
          ) : null}
        </div>
      </>
    );
  }

  return <>{ReconServiciosPrevios()}</>;
};

export default memo(ReconServiciosPrevios);
